"use strict";

BryanAnthonys.loadedScripts['personalized-frame-preview'] = true;

BryanAnthonys.personalizedFramePreview = (function () {
    function createMarkup(variantTitle, personalizedFramesSection) {
        const frameEdgeImage = personalizedFramesSection.querySelector(`[data-canvas-frame="${variantTitle}"]`);

        const frameEdgeImageMarkup = frameEdgeImage ? ` 
            <img 
                class="personalized-frame-preview-edge" src="${frameEdgeImage.dataset.src}" 
                alt="${frameEdgeImage.getAttribute('alt')}" width="93" height="68" 
            />
        ` : '';

        const printImagePadding = frameEdgeImage.dataset.padding;

        let zoomText = BryanAnthonys.strings.accessibility.noTouchZoom;
        if (BryanAnthonys.device.hasTouchscreen()) {
            zoomText = BryanAnthonys.strings.accessibility.touchZoom;
        }

        return `
            <div class="overflow-hidden">
                <div class="personalized-frame-preview mx-auto" data-personalized-frame-preview>
                    <img 
                        class="personalized-frame-preview-print block" data-personalized-frame-preview-customer-image
                        alt="Customized print image" width="4200" height="3000"  style="padding: ${printImagePadding}"
                    />
                    ${frameEdgeImageMarkup}
                </div>

                <div class="personalized-frame-preview__viewer-image-help center p-2" aria-hidden="true">
                    <svg class="icon icon-pinch-zoom">
                        <use xlink:href="#icon-pinch-zoom"/>
                    </svg>
                    <span class="block size-11">
                        ${zoomText}
                    </span>
                </div>
            </div>
        `;
    }

    function openModal(opener, addHeader = false, cartDrawerIsOpen = false) {
        const url = `/products/${BryanAnthonys.escapeHtml(opener.dataset.productHandle)}`;

        document.querySelectorAll('personalized-frame-preview-modal').forEach(modal => modal.remove());

        document.body.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
          <personalized-frame-preview-modal
            id="ProductFramePreview" data-animated="true" data-animation-duration="300"
            class="custom-modal custom-modal--animate-drop custom-modal--centered presonalized-frame-modal"
            data-content-url="${url}" data-inherits-from-modal ${cartDrawerIsOpen ? `data-scope="CartDrawer"` : ''}
          >
            <div 
              class="custom-modal__content" role="dialog" aria-modal="true" tabindex="-1" aria-label="Frame preview" 
              style="width: 96%; --max-width: 120rem;"
            >
              <button 
                id="ModalClose-ProductFramePreview" aria-label="Close modal" type="button"
                class="custom-modal__toggle custom-modal__toggle--borderless custom-modal__toggle--corner custom-modal__toggle--transparent"
              >
                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                  <use href="#icon-close"></use>
                </svg>
              </button>
              <div class="custom-modal__content-info">
                <div class="custom-modal__loading" data-modal-loading="">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </div>
            </div>
          </personalized-frame-preview-modal>
        `)));

        const modal = document.getElementById('ProductFramePreview');
        modal.variantTitle = opener.dataset.variantTitle;
        modal.mergedImage = new URL(opener.dataset.image).toString();
        if (modal.mergedImage.indexOf('https://') === 0 && modal.mergedImage.indexOf('?') === -1) {
            modal.mergedImage += '?width=2000';
        }
        modal.addHeader = addHeader;
        modal.show();
    }

    return {createMarkup, openModal};
})();

customElements.define('personalized-frame-preview-opener', class extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => BryanAnthonys.personalizedFramePreview.openModal(this));
    }
});

customElements.define('personalized-frame-preview-modal', class extends ModalDialog {
    renderAjaxContent(html) {
        const placeholder = this.querySelector('[data-modal-loading]');
        if (placeholder) {
            const section = new DOMParser().parseFromString(html, 'text/html');
            let preview = BryanAnthonys.personalizedFramePreview.createMarkup(
                this.variantTitle,
                section
            );
            if (this.addHeader) {
                preview = section.querySelector('[data-frame-preview-header-template]').innerHTML + preview;
            }
            placeholder.insertAdjacentHTML('beforebegin', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(preview)));
            placeholder.remove();
            this.querySelector('[data-personalized-frame-preview-customer-image]').src = this.mergedImage;

            const zoomablePreview = this.querySelector('[data-personalized-frame-preview]');
            if (zoomablePreview) {
                this.activatePanzoom(zoomablePreview);
            }
        }
    }

    activatePanzoom(zoomablePreview) {
        if (typeof panzoom !== 'function') {
            this.loadPanzoom(zoomablePreview);

            return;
        }

        const scrollLeft = (zoomablePreview.clientWidth - zoomablePreview.parentElement.clientWidth) / 2;
        if (scrollLeft > 0) {
            zoomablePreview.parentElement.style.left = `-${scrollLeft}px`;
        }

        this.panzoom = panzoom(zoomablePreview, {
            bounds: true,
            maxZoom: 7,
            minZoom: 1,
            initialX: 0,
            initialY: 0,
            boundsPadding: 0
        });

        this.classList.add('personalized-frame-preview--help-visible');

        const onZoom = () => {
            this.classList.remove('personalized-frame-preview--help-visible');
            this.panzoom.off('zoom', onZoom);
        };

        this.panzoom.on('zoom', onZoom);
    }

    loadPanzoom(zoomablePreview) {
        BryanAnthonys.loadScript('panzoom', {
            callback: () => {
                this.activatePanzoom(zoomablePreview);
            }
        });
    }
});